import React from 'react'
import ButtonGroup from '@mui/material/ButtonGroup'
import CliniquesSwitcherButton from 'components/ui/CliniquesSwitcherButton'
import IconSquares from 'assets/images/icon-squares.svg'
import IconMap from 'assets/images/icon-map.svg'

export default () => (
  <ButtonGroup>
    <CliniquesSwitcherButton buttonView="cards" icon={IconSquares} />
    <CliniquesSwitcherButton buttonView="map" icon={IconMap} />
  </ButtonGroup>
)
